import { render, staticRenderFns } from "./veStuReservationShow.vue?vue&type=template&id=0d806144&scoped=true"
import script from "./veStuReservationShow.vue?vue&type=script&lang=js"
export * from "./veStuReservationShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d806144",
  null
  
)

export default component.exports